import { mapState } from 'vuex'
import lowDash from '@/utils/convert-to-low-dash'

export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('forms', ['serverErrors']),
  },

  methods: {
    appendErrorClass(field) {
      return this.v.$error || !!this.serverErrors[lowDash(field)]
    },

    lowDash(str) {
      return lowDash(str)
    },
  },
}
